// i18n area 'networks' — locale fi-FI (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.fi-FI.meta.json.
import type { enUS } from './networks'

export const fiFI: typeof enUS = {
  networks: {
    common: {
      name: 'Nimi',
      scope: 'Scope',
      operState: 'Tila',
      actions: 'Toiminnot',
      create: 'Luo',
      close: 'Sulje',
      cancel: 'Peruuta',
      delete: 'Poista',
      edit: 'Muokkaa',
      save: 'Tallenna',
      editError: 'Muokkaus epäonnistui',
      search: 'Hae nimellä',
      empty: 'Täällä ei ole vielä mitään',
      saveError: 'Tallennus ei onnistunut',
      loadError: 'Lataus ei onnistunut — onko TVirt-backend tavoitettavissa?',
      createError: 'Luonti epäonnistui',
      deleteError: 'Poisto epäonnistui',
      deleteConfirmTitle: 'Poistetaanko {name}?',
      deleteConfirmBody: 'Toimintoa ei voi perua.',
      nameHint: 'Pienet kirjaimet, numerot ja väliviivat (DNS-1123)',
      up: 'Aktiivinen',
      down: 'Ei aktiivinen',
      unknown: 'Tuntematon',
      usedByVMs: 'VM',
      emptyTable: 'Ei merkintöjä — lisää yksi +-painikkeella'
    },
    dialogTabs: {
      general: 'Yleiset',
      base: 'Perusmäärittely',
      advanced: 'Lisäasetukset',
      reserved: 'TVirtille varatut ranget',
      position: 'Sijainti',
      network: 'Verkkoasetukset',
      hosts: 'Osallistuvat solmut'
    },
    reservedRanges: {
      note: 'Nämä ovat TVirtille varatut IP-ranget, joista TVirt voi jakaa osoitteen automaattisesti VM:ille, containereille jne. HUOM: näiden rangejen IP-osoitteita ei saa käyttää TVirtin ulkopuolella ulkoisissa palveluissa/laitteissa.',
      from: 'Alkaen',
      to: 'Asti'
    },
    overlay: {
      title: 'Overlay-verkot',
      createTitle: 'Luo overlay-verkko',
      editTitle: 'Muokkaa overlay-verkkoa',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — jaetaan automaattisesti, jos jätetään tyhjäksi',
      subnet: 'Aliverkko',
      subnetHint: 'Overlayn CIDR — IPAM johtaa siitä rekisterimerkinnän automaattisesti',
      mtu: 'MTU',
      weight: 'Paino',
      ceilMbps: 'Katto (Mbps)',
      fairnessHint: 'Paino vaikuttaa vain ruuhkassa: vapaalla linkillä jokainen verkko voi käyttää koko kaistan. Katto on sen sijaan aina voimassa.',
      contention: 'Kilpailu',
      contentionTip: 'Vähintään yksi solmu havaitsee tämän verkon luokalla pudotuksia tai ylityksiä JA jonoa: uplinkin kaistasta kilpaillaan ja painot vaikuttavat. Kuinka paljon ja mistä lähtien näkyy solmun net.shaping.*-sarjoissa.',
      firewallPolicy: 'Firewall-käytäntö',
      hosts: 'Hostit',
      hostsTitle: 'Osallistuvat solmut',
      hostsHint: 'Jokainen solmu ilmoittaa underlay-endpointtinsa — valinta solmun TODELLISISTA osoitteista, jotka luetaan sen verkkoasetuksista; valinnaisen overlay-osoitteen pitää olla aliverkossa. Osallistuminen on placement-rajoite.',
      hostNode: 'Solmu',
      hostUnderlay: 'Underlay-IP',
      hostUnderlayPickNode: 'Valitse ensin solmu',
      hostAddress: 'Osoite overlayssa (valinnainen)',
      hostAddressOutside: 'Overlay-aliverkon ulkopuolella ({cidr})',
      addHost: 'Lisää solmu',
      observedAt: 'Havaittu',
      attachedNics: 'Liitetyt NIC:t'
    },
    services: {
      title: 'Verkkopalvelut',
      createTitle: 'Luo verkkopalvelu',
      editTitle: 'Muokkaa verkkopalvelua',
      kind: 'Tyyppi',
      kindCategory: 'Palvelut',
      selectKindHint: 'Valitse palvelun tyyppi — taustalla oleva daemon on toteutusyksityiskohta, jonka TVirt hoitaa puolestasi.',
      kindLabel: {
        dhcp: 'DHCP-palvelin',
        ntp: 'NTP-palvelin',
        vpn: 'VPN-palvelin',
        dns: 'DNS-palvelin',
        gateway: 'Gateway',
        'lb-rp': 'Load balancer ja reverse proxy',
        floatip: 'Kelluva IP'
      },
      kindDesc: {
        dhcp: 'Jakaa osoitteita palvelluissa aliverkoissa — poolit johdetaan verkon aliverkosta, gatewaysta ja TVirtille varatuista rangeista.',
        dns: 'Autoritatiivinen DNS ilmoitetuille vyöhykkeille — recordit johdetaan IPAMista, ja päälle tulevat käsin lisäämäsi.',
        gateway: 'Solmu toimii verkon gatewayna — NAT (DNAT, 1:1, SNAT/masquerade) sekä staattinen reititys liitettyjen verkkojen välillä, suunniteltu itsekorjautuvaksi.',
        'lb-rp': 'Kuormantasaaja / käänteisproxy palveluidesi edessä — L4- tai L7-kuuntelijat jäsenpoolien tai Podin valmiiden instanssien päällä, uudelleenmääritettyinä lennossa.',
        ntp: 'Verkkojen aikapalvelu — ulkoisten upstream-palvelinten relay, tai solmun kello tarjottuna clienteille.',
        vpn: 'VPN-keskitin solmulla — WireGuard tai OpenVPN, sinä valitset: etäkäyttö liikkuville clienteille, tai site to site -tunneli kahden verkon välillä.',
        floatip: 'Yksi osoite, joka on kerrallaan vain yhdellä terveellä App-instanssilla tai Podilla ja siirtyy seuraavaan terveeseen kohteeseen sen kaatuessa — failover ilman daemoneita; tasaus jää kuormantasaajalle.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Kelluva IP elää valitussa verkossa LISÄosoitteena haltijainstanssin omassa nimiavaruudessa: ei portteja, ei tasausta, ei NAT:ia — asiakkaan IP pysyy aitona.',
        address: 'Kelluva IP',
        targets: 'Kohteet',
        targetsHint: 'ETUSIJAjärjestyksessä: ensimmäinen terve kohde pitää osoitteen. Pod tarkoittaa kaikkia sen instansseja replikoittain; jokaisella kohteella on oma terveyskriteerinsä. Jokaisen kohteen on oltava liitetty samaan verkkoon.',
        targetKind: 'Kohde',
        targetApp: 'App-instanssi',
        targetPod: 'Pod (kaikki instanssit)',
        targetRef: 'Mikä',
        health: 'Terveys',
        healthRunning: 'Käynnissä (jokainen kontti valmis)',
        healthTcp: 'TCP-yhteys',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Portti',
        path: 'Polku',
        addTarget: 'Lisää kohde',
        moveUp: 'Siirrä ylös',
        moveDown: 'Siirrä alas',
        preempt: 'Preempt',
        preemptHint: 'Pois (oletus): terve haltija pitää osoitteen, vaikka korkeampi kohde palaisi — ei heilahtelua. Päällä: ensimmäinen terve kohde pitää sen aina.',
        holder: 'Haltija',
        noHolder: 'ei tervettä kohdetta',
        since: 'alkaen',
        verdicts: 'Havaitut kohteet',
        healthy: 'terve',
        unhealthy: 'epäterve',
        noVerdict: 'Ei vielä päätetty — auktoriteettisolmu kirjoittaa ensimmäisen tuomion seuraavalla kierroksellaan.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Tämä instanssi pitää palvelun {service} kelluvaa IP:tä {address}'
      },
      poolSource: 'Päätepisteet',
      poolSourceMembers: 'Staattiset jäsenet',
      poolSourcePod: 'Podin valmiit instanssit',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Portti',
      poolBackendHint: 'Päätepisteet seuraavat Podia: instanssi liittyy, kun se on käynnissä jokainen kontti valmiina, ja poistuu heti, kun sitä pienennetään tai se kuolee. Aktiivinen tarkistus on oletuksena päällä.',
      poolBackendCount: 'Podin {pod} valmiit instanssit portissa {port}',
      node: 'Solmu',
      enabled: 'Käytössä',
      parked: 'Pysäköity',
      subnets: 'Aliverkot',
      subnetsHint: 'Tämän instanssin palvelemat IPAM-aliverkot — poolit johdetaan CIDR:stä, gatewaysta ja TVirtille varatuista rangeista',
      noSubnets: 'Ei IPAM-aliverkkoja — ilmoita ensin looginen fabric-verkko (tai overlay-aliverkko): IPAM johdetaan niistä',
      iface: 'Kuunteluliitäntä',
      ifaceHint: 'Isäntäliitäntä, jolla palvelu avaa sokettinsa (esim. silta) — pakollinen: verkkopalvelu on itsenäinen, "kaikki liitännät" ei ole enää olemassa',
      dns: 'DNS-palvelimet',
      domain: 'Verkkotunnus',
      detail: 'Palvelee',
      subnetCount: '{n} aliverkkoa',
      zones: 'Vyöhykkeet',
      zonesHint: 'Vain autoritatiivinen — daemon ei koskaan tee rekursiivisia kyselyjä. A-recordit johdetaan solmujen ilmoitetuista osoitteista viitatuissa IPAM-aliverkoissa; reverse-kytkin palvelee myös vastaavat in-addr.arpa-vyöhykkeet (PTR). Yhtä vyöhykettä palvelee korkeintaan yksi DNS-instanssi koko laivastossa. Valinnainen nameserver on FQDN, joka kirjoitetaan NS/SOA-recordeihin oletuksen ns.<vyöhyke> sijaan; jos se osuu vyöhykkeen sisään, sen A-record johdetaan silti palvelevasta solmusta.',
      zoneName: 'Vyöhykkeen nimi',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM-aliverkot',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Manuaaliset recordit',
      zoneRecordsHint: 'Yksi per rivi: nimi TYYPPI arvo — tyypit A, CNAME, MX, TXT. Jos nimi törmää, manuaalinen record voittaa johdetun.',
      addZone: 'Lisää vyöhyke',
      lbListeningHint: 'Instanssi ilmoittaa YHDEN kuunteluverkon ja YHDEN osoitteen — jokainen kuuntelija sitoo sen omaan porttiinsa; toinen osoite on toinen palvelu.',
      listeners: 'Listenerit',
      listenersHint: 'Jokainen kuuntelija sitoo instanssin osoitteen omaan porttiinsa tilassa L4 (TCP-läpivienti — tavuja ei koskaan avata) tai L7 (HTTP) ja välittää yhteen alla olevista pooleista. Osoite/portti-parin palvelee enintään yksi instanssi solmua kohden. Muutokset astuvat voimaan lennossa — ei uudelleenkäynnistystä, ei menetettyjä yhteyksiä.',
      listenerName: 'Nimi',
      listenerMode: 'Tila',
      modeL7: 'L7 — reverse proxy (HTTP)',
      modeL4: 'L4 — TCP-passthrough',
      listenerPort: 'Portti',
      listenerPool: 'Pool',
      addListener: 'Lisää listener',
      pools: 'Poolit',
      poolsHint: 'Backendit, joihin liikenne laskeutuu: staattiset jäsenet tasattuina round-robinilla tai vähiten kuormitetulle, valinnaisella aktiivisella health checkillä, joka poistaa sairaat jäsenet rotaatiosta.',
      poolName: 'Nimi',
      poolAlgorithm: 'Algoritmi',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Vähiten kuormitettu',
      poolCheck: 'Health check',
      checkNone: 'Ei mitään',
      checkTcp: 'TCP-yhteys',
      checkHttp: 'HTTP',
      poolCheckPath: 'Tarkistuspolku',
      poolInterval: 'Väli (s)',
      poolMembers: 'Jäsenet',
      poolMembersHint: 'Yksi per rivi: osoite:portti, valinnaisesti perässä paino (1-128) — esim. 10.0.0.21:8080 2',
      addPool: 'Lisää pool',
      memberCount: '{n} jäsentä',
      listen: {
        assignment: 'Osoitteen määräytyminen',
        assignmentStatic: 'Staattinen osoite',
        assignmentAuto: 'Automaattinen (TVirt-varatut alueet)',
        autoHint: 'TVirt poimii osoitteen loogisen verkon varatuista alueista ja pitää sen stickynä — ei koskaan poimita uudelleen muokkauksessa tai failoverissa.',
        title: 'Kuuntelijat',
        hint: 'Verkkopalvelu on itsenäinen: jokainen kuuntelija ilmoittaa verkkonsa (overlay, fabricin looginen verkko tai raaka liitäntä) ja osoitteen sen aliverkosta — yksi kuuntelija osoitetta kohden, jokerimerkkiä ei enää ole. DNS ja NTP voivat kuunnella useissa verkoissa ja niiden verkkojen useissa osoitteissa.',
        address: 'Kuunteluosoite',
        add: 'Lisää kuuntelija'
      },
      ntp: {
        mode: 'Synkronointitapa',
        modeRelay: 'Ulkoisten palvelinten relay',
        modeNodeClock: 'Solmun kello',
        modeHint: 'Relay tarjoaa ajan ilmoitetuilta upstream-palvelimilta; solmun kello tarjoaa palvelevan solmun ajan — jonka klusteri pitää joka tapauksessa synkronoituna',
        servers: 'Upstream-palvelimet',
        serversHint: 'Pilkulla eroteltuina — hostname tai IP-osoite; palvelu ottaa ajan täältä ja tarjoaa sen verkolle',
        port: 'Kuunteluportti',
        listening: 'Kuuntelee osoitteessa'
      },
      vpn: {
        engine: 'Moottori',
        engineHint: 'Sinä valitset, eikä se enää vaihdu: WireGuard on moderni, nopea ja in-kernel; OpenVPN on yhteensopivuuden veteraani (TCP, vihamieliset verkot)',
        engineLocked: 'Moottori on muuttumaton — toinen moottori on uusi palvelu, avaimet ja varmenteet eivät ole siirrettävissä',
        mode: 'Tila',
        modeRemote: 'Etäkäyttö',
        modeSite: 'Site to site',
        modeHint: 'Etäkäyttö antaa liikkuville clienteille osoitteen tunnelissa; site to site yhdistää kaksi verkkoa',
        port: 'Kuunteluportti',
        protocol: 'Kuljetus',
        protocolWireguardHint: 'WireGuard puhuu vain UDP:tä',
        tunnelSubnet: 'Tunnelin aliverkko',
        tunnelSubnetHint: 'Verkko, jossa clientit elävät — kirjattu IPAM-rekisteriin, syntyy ja kuolee tämän palvelun mukana',
        dnsServers: 'Clienteille työnnettävät DNS-palvelimet',
        routes: 'Clienteille työnnettävät reitit',
        routesHint: 'Pilkulla erotellut verkot, jotka ovat tavoitettavissa tunnelissa; tunnelin aliverkko on aina mukana',
        peers: 'Peerit',
        peersHint: 'Jätä julkinen avain tyhjäksi, niin TVirt generoi avainparin — ja toimittaa sen profiilin mukana. Liitä avain, niin peer pitää omansa.',
        clients: 'Clientit',
        clientsHint: 'Jokainen client saa varmenteen tämän palvelun CA:lta. Clientin poistaminen MITÄTÖI sen: CRL generoidaan heti uudelleen.',
        peerName: 'Nimi',
        publicKey: 'Julkinen avain',
        publicKeyMinted: 'TVirt generoi sen',
        peerAddress: 'Osoite tunnelissa',
        peerAddressHint: 'Tyhjä = jaetaan',
        allowedIps: 'Etäaliverkot',
        allowedIpsHint: 'Pilkulla eroteltuina, reititetään tämän peerin kautta',
        endpoint: 'Endpoint',
        presharedKey: 'Esijaettu avain',
        keepalive: 'Keepalive (s)',
        addPeer: 'Lisää peer',
        addClient: 'Lisää client',
        auth: 'Todennus',
        authTls: 'Varmenteet (TLS)',
        remote: 'Etä-endpoint',
        remoteHint: 'Etäpään host:portti — tyhjä tarkoittaa, että tämä pää odottaa',
        peerRoutes: 'Etäaliverkot',
        serverPublicKey: 'Tämän palvelimen julkinen avain',
        ca: 'Varmenteiden myöntäjä',
        listening: 'Kuuntelee osoitteessa',
        tunnel: 'Tunneli',
        peerCount: '{n} peeriä',
        download: 'Lataa profiili',
        downloadError: 'Profiilia ei voitu viedä',
        lastHandshake: 'Viimeisin handshake',
        never: 'ei koskaan',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Yhdistetty',
        idle: 'Toimeton'
      },
      gateway: {
        attach: 'Kuunteluverkon tyyppi',
        attachOverlay: 'Overlay-verkko',
        attachNetwork: 'Looginen fabric-verkko',
        attachInterface: 'Raaka liitäntä',
        overlay: 'Overlay-verkko',
        network: 'Looginen verkko',
        interface: 'Liitännän nimi',
        interfaceHint: 'Host-liitäntä, jota TVirt ei hallinnoi — osoite otetaan sellaisenaan',
        address: 'Kuunteluosoite (gateway)',
        addressHint: 'Gateway-osoite, johon clientit osoittavat — kuunteluverkon aliverkon sisällä',
        dnatTitle: 'DNAT-säännöt',
        dnatHint: 'Kohde-NAT: matchiin osuva liikenne ohjataan uuteen osoitteeseen (ja valinnaisesti uuteen porttiin). Mikä tahansa listan protokollista — portit siellä, missä protokolla niitä kantaa.',
        snatTitle: 'SNAT-säännöt',
        snatHint: 'Lähde-NAT: matchiin osuva liikenne lähtee ulos uudelleenkirjoitetulla lähteellä — eksplisiittinen uusi osoite (ja valinnaisesti uusi portti), tai masquerade lähtöosoitteella, jos jätetään tyhjäksi.',
        oneToOneTitle: '1:1 NAT -säännöt',
        oneToOneHint: 'Jokainen ulkoiselle osoitteelle tuleva paketti mapataan sisäiseen, ja sisäinen host lähtee ulos ulkoisena — kaikki protokollat, molemmat suunnat.',
        external: 'Ulkoinen osoite',
        internal: 'Sisäinen osoite',
        addOneToOne: 'Lisää 1:1-sääntö',
        family: 'Perhe',
        protocol: 'Protokolla',
        source: 'Lähde (osoite/aliverkko)',
        destination: 'Kohde (osoite/aliverkko)',
        invert: 'NOT',
        srcPorts: 'Lähdeportit',
        dstPorts: 'Kohdeportit',
        dstPortsHint: 'Portti tai range (80, 8000-8099)',
        toAddress: 'Uusi osoite',
        toPort: 'Uusi portti',
        snatTo: 'Uusi lähde (tyhjä = masquerade)',
        snatToHint: 'Eksplisiittinen lähdeosoite; tyhjä = masquerade lähtöosoitteella',
        addDnat: 'Lisää DNAT-sääntö',
        addSnat: 'Lisää SNAT-sääntö',
        routesTitle: 'Staattiset reitit',
        routesHint: 'Solmu reitittää liitettyjensä verkkojen välillä (IP forwarding on päällä); nämä reitit lisäävät tavoitettavuutta niiden yli — puhdasta kerneliä, dynaaminen reititys tulee myöhemmässä roundissa.',
        routeDestination: 'Kohdealiverkko',
        routeGateway: 'Next hop',
        routeMetric: 'Metriikka',
        addRoute: 'Lisää reitti',
        listening: 'Kuuntelee osoitteessa',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} reittiä'
      },
      unknownSince: 'Tuntematon — viimeisin report {m} min sitten',
      lastWord: 'Viimeinen sana',
      reportObservedAt: 'Viimeisin report',
      lastErrorRow: 'Viimeisin virhe',
      recordsCount: '{n} manuaalista recordia',
      phase: {
        configured: 'Konfiguroitu',
        running: 'Käynnissä',
        error: 'Virhe'
      },
      authorityNode: 'Authority (määrätty sijainti)',
      preferredNode: 'Ensisijainen solmu',
      preferredNodeHint: 'Pehmeä suosikki, ei koskaan rajoite: seuraavassa placement-päätöksessä instanssi laskeutuu tänne, jos jäsen on kelvollinen — yksinään se ei siirrä mitään; siirto on "Siirrä authority".',
      noPreference: 'Ei suosikkia (automaattinen placement)',
      moving: 'Liikkeessä',
      movingTooltip: 'Havaittu täällä, kun authority osoittaa solmuun {node}: siirto konvergoi.',
      placement: {
        title: 'Placement',
        loading: 'Kartoitus käynnissä…',
        loadError: 'Placement-kartoitus ei vastannut — yritä myöhemmin uudelleen.',
        draftHint: 'Kartoitus lasketaan ilmoitetusta verkkoliitännästä: se ilmestyy, kun palvelu on luotu. Luonti hylätään, jos yksikään jäsen ei voi palvella sitä, ja hylkäys nimeää mekanismin, joka tyhjensi joukon.',
        eligibleCount: '{n} jäsentä {m}:stä voi palvella tätä instanssia',
        recommended: 'Suositeltu',
        eligible: 'Kelvollinen',
        notEligible: 'Ei kelvollinen',
        blockedReachability: 'verkko ei ulotu tälle jäsenelle',
        blockedRequireTag: 'pakollisen tagin estämä (requireNodes)',
        blockedExcluded: 'simulaation poissulkema',
        preferenceUnknown: 'ei ole (enää) klusterin jäsen',
        preferenceIgnored: 'Suosikki "{node}" ei ole tänään kelvollinen: {reason}. Kartoituksen suositus voittaa — ei koskaan virhe, palvelu elää muualla.',
        emptyReachability: 'Yksikään jäsen ei voi palvella tätä instanssia: verkko ei ulotu minnekään — mikään tagien hienosäätö ei auta. Kaapeloi solmu tai siirrä palvelu sinne, missä verkko on.',
        emptyRequireTag: 'Yksikään jäsen ei voi palvella tätä instanssia: pakolliset tagit tyhjensivät joukon — poista rivi requireNodesista tai lisää tag jollekin jäsenelle.',
        spof: 'Yksittäinen vikaantumispiste',
        spofDetail: 'Vain yksi jäsen voi isännöidä instanssia: vikatilanteessa failoverilla ei ole minne mennä. Multi-listener-palvelu siirtyy YHTENÄ KOKONAISUUTENA — ehdokkaan on nähtävä KAIKKI sen verkot: se on hinta.',
        whatIf: 'Simuloi poissaolevia jäseniä',
        whatIfHint: 'Drainin what-if: kysy ENNEN evakuointia, älä huomaa sitä vasta failoverissa.',
        survives: 'Vaikka {nodes} puuttuisi, palvelulla on yhä koti.',
        notSurvives: '{nodes}:n evakuointi jättää tämän palvelun NURIN: johdettu rajoite voittaa saatavuuden (R30) — daemon, joka elää siellä, minne verkko ei ulotu, ei palvele ketään eikä hälytä ketään.',
        transfer: 'Siirrä authority',
        transferError: 'Siirto epäonnistui',
        transferTarget: 'Kohdejäsen',
        transferHint: 'Vain kelvolliset jäsenet ovat tarjolla — suosikki sallitun joukon sisällä, ei koskaan override. Ei taskia: workerien seuraava kierros ON siirto (vanha solmu niittää, uusi pystyttää).'
      }
    },
    fabric: {
      tabDerivation: 'Johdanta',
      importNetwork: 'Tuo toisesta fabricista',
      importTitle: 'Tuo looginen verkko',
      importHint: 'Tuonti on eksplisiittinen liittyminen: verkko pysyy omistajan (sama identiteetti, sama stem, sama bridge tvf-<stem>) ja täältä se kartoitetaan tämän fabricin porteille/LAGG:eille — kartoittaminen ON väite, että toimitus päätyy samaan L2-alueeseen kuin omistajalla.',
      importPick: 'Omistajan verkko',
      importNone: 'Ei tuotavaa: muilla fabriceilla ei ole omaa verkkoa, jota tämä fabric ei jo tuntisi',
      importedNetworksTitle: 'Tuodut verkot',
      noImported: 'Ei tuotuja verkkoja',
      importedFrom: 'tuotu fabricista {fabric}',
      importedBy: 'Tuojat: {list}',
      importedCount: '+{n} tuotua',
      owner: 'Omistaja',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Poista tuonti',
      unimportConfirm: 'Poistetaanko verkon {name} (omistaja {fabric}) tuonti tästä fabricista? Hylätään niin kauan kuin tämän fabricin portti tai LAGG kartoittaa sen, tai vierasta, Appia tai palvelua palvellaan vain tämän jalan kautta.',
      unimportRefused: 'Tuonti on yhä käytössä — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Tämä node saa tuon verkon jo toisesta fabricista, jonka jäsen se on: node ottaa jaetun verkon vain YHDEN jalkansa kautta (kaksi saman L2:n uplinkiä bridgessä ilman STP:tä on silmukka). Pura kartoitus toisen fabricin porteilta tai LAGG:lta.',
          otherFabricDerived: 'Dokumentti kantaa sellaisen fabricin lohkoa, jota kohti node ei enää ilmoita kaapelia: sovella ensin sen fabricin suunnitelma (se ehdottaa sen laitteiden poistoa), tai ota ne haltuun take-ownershipilla, jos fabricia ei enää ole.'
        },
        hint: 'O.3-johdantasuunnitelma: jokaiselle kaapeloidulle nodelle tila, diff johdettu-vs-nykyinen, ILMOITETTU bond-topologia, dual-stack-flipit ja rakenteiset hylkäykset/varoitukset. Vain luku EKSPLISIITTISEEN applyyn asti — mikään ei koskaan laskeudu nodelle itsestään.',
        refresh: 'Lataa suunnitelma uudelleen',
        empty: 'Yhtään nodea ei ole kaapeloitu tähän fabriciin (eikä yksikään kanna enää sen lohkoa).',
        refusal: 'Hylkäys',
        warning: 'Varoitus',
        generation: 'dokumentin sukupolvi {n}',
        state: {
          manual: 'Manuaalinen',
          derived: 'Johdettu',
          diverged: 'Poikennut'
        },
        topologyTitle: 'Ilmoitettu topologia',
        members: 'jäsenet',
        primary: 'ensisijainen',
        held: 'pidetty YHDELLÄ jäsenellä',
        form: {
          perNetworkBond: 'Bond verkkoa kohti',
          singleBond: 'Yksi fallback-bond',
          laggBond: 'LACP-bond (LAGG)',
          singlePort: 'Yksi portti'
        },
        colAction: 'Toiminto',
        colKind: 'Laji',
        colDevice: 'Device',
        colDetail: 'Yksityiskohta',
        action: {
          add: 'lisää',
          remove: 'poista',
          replace: 'korvaa'
        },
        diffEmpty: 'Ei odottavaa diffiä — sovellettu dokumentti vastaa renderiä.',
        diffBlocked: 'Ei diffiä: yllä olevat hylkäykset estävät tämän noden.',
        phasePlanned: 'suunniteltu (vaihe 1/3)',
        phaseDraining: 'tyhjenemässä (vaihe 2/3)',
        probeUnobserved: 'Tyhjennysanturi: ei koskaan raportoitu — tyhjyys on TUNTEMATON (retire hylättäisiin nyt).',
        probeFailed: 'Tyhjennysanturi: havainto EPÄONNISTUI — tunnetut aikaleimat kulkevat mukana, ei koskaan «tyhjä», jota kukaan ei mitannut.',
        probeActive: {
          one: 'Anturi: {n} muodostettu yhteys yhä vanhassa osoitteessa',
          other: 'Anturi: {n} muodostettua yhteyttä yhä vanhassa osoitteessa'
        },
        probeLastActive: 'viimeisin aktiivisuus {time}',
        probeEmpty: {
          one: 'Anturi: tyhjä {n} minuutin ajan',
          other: 'Anturi: tyhjä {n} minuutin ajan'
        },
        probeEmptyUnknown: 'Anturi: tyhjä (mistä lähtien, ei tiedossa).',
        impact: '{nics} vNIC:tä ja {apps} Appia tällä nodella käyttävät näitä verkkoja: {list}',
        apply: 'Sovella tälle nodelle',
        applyTitle: 'Sovella johdanta — {node}',
        applyIntro: 'Johdettu konfiguraatio kirjoittaa noden {node} verkkodokumentin uudelleen ({n} muutosta) samasta ovesta kuin host-network-editori — NetworkManager-checkpoint ja rehellinen probe mukaan lukien. Suunnitelman varoitukset alla kulkevat mukana: lue ne ennen vahvistamista.',
        applyError: 'Apply epäonnistui',
        applyRefused: 'Node hylkäsi:',
        planMoved: 'Fabric muuttui tämän esikatselun jälkeen — MITÄÄN ei sovellettu. Suunnitelma on ladattu uudelleen: katso uudestaan ja yritä uudelleen.',
        retire: 'Poista käytöstä',
        retireTitle: 'Paluupisteen ohitus — osoitteen {address} poisto',
        restore: 'Palauta',
        restoreTip: 'Takaisin apply-toimintoa edeltäneeseen tilannekuvaan (sukupolvi {previous}) — yhden askeleen kumoaminen (H13)',
        restoreTitle: 'Palauta edellinen dokumentti — {node}',
        restoreIntro: 'Solmun {node} verkkodokumentti palaa viimeisintä applya edeltäneeseen tilannekuvaan (sukupolvi {previous}), kirjoitettuna uudelleen sukupolvena {next} sukupolven {current} tilalle. Worker konvergoi sen kuten minkä tahansa muun dokumentin.',
        restoreRedo: 'Korvattu dokumentti on uusi tilannekuva: uudelleen palauttaminen on redo.',
        restoreClosesChain: 'Tilannekuva on johdantoa edeltänyt manuaalinen dokumentti: ketju päättyy tähän — ei enempää kumoamista, solmu on manuaalinen seuraavaan applyyn asti.',
        restoreConfirm: 'Palauta',
        restoreError: 'Palautus epäonnistui',
        retireIntro: 'Tämä poistaa osoitteen {address} ({network}) pisteestä {point} lopullisesti. Tämän teon jälkeen paluutie on KÄÄNTEINEN flip — vanhan osoitteen uudelleenilmoitus saman moottorin kautta — ei koskaan sokea palautus.',
        retireOld: 'Vanha osoite (poistettu)',
        retireNew: 'Uusi osoite (jää)',
        retireEmptyFact: 'Tyhjennysanturi ilmoittaa osoitteen tyhjäksi: tämä poisto ei katkaise yhtään havaittua yhteyttä.',
        retireConfirm: 'Poista osoite',
        severActiveLoss: {
          one: 'Katkaise {n} muodostettu yhteys yhä vanhassa osoitteessa — se kuolee tämän teon myötä',
          other: 'Katkaise {n} muodostettua yhteyttä yhä vanhassa osoitteessa — ne kuolevat tämän teon myötä'
        },
        severUnknownLoss: 'Hyväksy TUNTEMATON: anturi ei ole koskaan havainnut tätä osoitetta (tai havainto epäonnistuu) — eläviä yhteyksiä voidaan katkaista.'
      },
      title: 'Fabric',
      createTitle: 'Luo fabric',
      networks: 'Verkot',
      switches: 'Switchit',
      ports: 'Portit',
      laggs: 'LAGGit',
      subnets: 'Aliverkot',
      tabOverview: 'Yleiskuva',
      tabNetworks: 'Loogiset verkot',
      tabSwitches: 'Switchit',
      overviewHint: 'Fabric yhdellä silmäyksellä: jokainen looginen verkko MTU:ineen ja aliverkkoineen (VLANit elävät vain per-portti/per-LAGG-mappauksissa — sama verkko voi kulkea eri tageilla eri porteissa). Fabric on ULKOISEN infrastruktuurin rekisteri — TVirt havainnoi ja ilmoittaa, ei koskaan provisioi, ja kajoaa vain sen hallintaan rekisteröityihin NIC:eihin.',
      absorptionHint: 'Jokainen tässä ilmoitettu aliverkko JOHTAA merkintänsä IPAM-rekisteriin samassa kirjoituksessa — se elää ja kuolee verkon mukana.',
      scopeFixedHint: 'Scope on kiinteä: klusterin juuri — fyysinen infrastruktuuri on määritelmällisesti koko klusterin laajuinen.',
      networksHint: 'Jokaisella verkolla on pakollinen MTU (oletus 1500) ja pakollinen aliverkko; tässä ilmoitetut gateway, DNS-palvelimet ja staattiset reitit ovat AINOA LÄHDE palvelinten NIC:eille, Appeille ja verkkopalveluille.',
      switchesHint: 'Manuaalinen rekisteri: portti on käyttämätön, mapattu (untagged-liikenne ja per-VLAN-tagit loogisille verkoille) tai LAGGin jäsen — jäsen ei kanna omia mappauksia.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Pakollinen — IPAM johtaa siitä rekisterimerkinnän automaattisesti',
      nodeAddressing: 'Solmujen osoitteistus',
      nodeAddressingNone: 'Ei mitään — ei osoitetta solmua kohden',
      nodeAddressingPool: 'Pool — yksi pysyvä osoite kutakin palveltua solmua kohden',
      nodeAddressingHint: 'Pool-tilassa fabric-johdanto antaa jokaiselle palvellulle solmulle osoitteen TVirt-järjestelmälle varatuista alueista (pysyvä myöntämisen jälkeen).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Varatut ranget',
      dns: 'DNS-palvelimet (pilkulla eroteltuina)',
      dnsShort: 'DNS',
      singleSourceHint: 'Tässä ilmoitetut gateway, DNS ja reitit ovat ainoa lähde — palvelinten NIC:t, Appit ja verkkopalvelut ammentavat täältä',
      routesTitle: 'Staattiset reitit',
      routeDestination: 'Kohde (CIDR)',
      routeVia: 'Via (next hop)',
      portUsed: 'Käytössä',
      vlanMappings: 'VLAN-mappaukset',
      vlanTag: 'VLAN-tagi',
      vlanNetwork: 'Looginen verkko',
      nameTaken: 'Nimi on jo käytössä fabricissa',
      addNetwork: 'Lisää verkko',
      editNetwork: 'Muokkaa verkkoa',
      deleteNetwork: 'Poista verkko',
      deleteNetworkConfirm: 'Poistetaanko looginen verkko {name} fabricista? Sen johdettu aliverkko IPAMissa kuolee sen mukana (hylätään niin kauan kuin palvelu tai App käyttää sitä). Siihen osoittavat portti- ja LAGG-kytkennät siivotaan.',
      switchName: 'Switch',
      portName: 'Portti',
      positionHint: 'Fyysinen sijainti (valinnainen) — sama sanasto kuin palvelinten sijoittelussa; vain deklaratiivinen',
      addSwitch: 'Lisää switch',
      editSwitch: 'Muokkaa switchiä',
      deleteSwitch: 'Poista switch',
      deleteSwitchConfirm: 'Poistetaanko switch {name} kaikkine portteineen? LAGGit kutistuvat vastaavasti (ja kuolevat alle kahden portin).',
      addPort: 'Lisää portti',
      editPort: 'Muokkaa porttia',
      deletePort: 'Poista portti',
      deletePortConfirm: 'Poistetaanko portti {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tagi:verkko)',
      taggedShort: 'Tagged',
      portCabling: 'Kaapelointi',
      portState: 'Tila',
      stateUnused: 'käyttämätön',
      stateMapped: 'mapattu',
      laggPortGuard: 'LAGGin jäsenporttia muokataan LAGGin puolelta',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG on 2+ porttia LACP:llä ja voi ulottua usealle switchille (MLAG, läpinäkyvästi); mukaan pääsevät vain käyttämättömät portit, LAGG on mappauspinta, ja poistettu portti palaa käyttämättömäksi.',
      addLagg: 'Lisää LAGG',
      editLagg: 'Muokkaa LAGGia',
      deleteLagg: 'Poista LAGG',
      deleteLaggConfirm: 'Poistetaanko LAGG {name}? Sen jäsenportit palaavat käyttämättömiksi.',
      lacpRate: 'LACP-rate',
      laggPorts: 'Jäsenportit (2+)',
      laggPortsHint: 'Mukaan pääsevät vain käyttämättömät portit — vapauta mapattu portti ensin',
      noNetworks: 'Ei ilmoitettuja loogisia verkkoja.',
      noSwitches: 'Ei ilmoitettuja switchejä.',
      noLaggs: 'Ei ilmoitettuja LAGGeja.',
      staleConflict: 'Toinen käyttäjä muutti tätä fabricia samalla kun muokkasit sitä: tallennus hylättiin, jotta hänen työnsä ei pyyhkiydy pois. Muutoksesi ovat yhä tässä, koskemattomina. Päivitetty fabric on jo ladattu uudelleen: vahvista uudelleen, niin ne sovelletaan sen päälle, tai peruuta ja katso mikä muuttui.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Vain johdettu: jokainen aliverkko syntyy loogisesta fabric-verkosta tai overlaysta — muokkaus tehdään lähteellä. Jaetut osoitteet näyttävät, KUKA niitä pitää; TVirtille varatut ranget ovat automaattisen jaon poolit.',
      search: 'Hae nimellä, CIDR:llä tai osoitteella',
      empty: 'Ei verkkoja — ilmoita looginen fabric-verkko tai overlay-aliverkko: IPAM johdetaan niistä automaattisesti.',
      reserved: 'TVirtille varatut ranget',
      address: 'Osoite',
      origin: 'Alkuperä',
      origin_declared: 'ilmoitettu',
      origin_observed: 'havaittu',
      holder: 'Haltija',
      noAddresses: 'Ei tunnettuja osoitteita tässä aliverkossa.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Muokkaa lähteellä'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Palomuuriryhmät',
      createTitle: 'Uusi palomuuriryhmä',
      editTitle: 'Muokkaa palomuuriryhmää',
      empty: 'Ei vielä palomuuriryhmiä — luo yksi: uudelleenkäytettävä sääntösanasto, johon guest-NIC:t viittaavat nimellä.',
      nameHint: 'Kirjaimet, numerot ja sisäiset . - _; yksilöllinen scopensa sisällä (muualla olevat kaimat erottuvat muodolla /scope/nimi)',
      description: 'Kuvaus',
      descriptionHint: 'Yksi rivi aikomuksesta, näkyy kaikkialla missä ryhmä valitaan',
      enforced: 'Pakotettu scopeen',
      enforcedHint: 'Pois: puhdas sanasto — säännöt sitovat vain ne NIC:t, jotka viittaavat ryhmään. Päällä: säännöt sitovat jokaisen guest-NIC:n, jonka palomuuri on päällä, ryhmän scopen alla — viitattiin tai ei.',
      enforcedChip: 'Pakotettu',
      enforcedChipHint: 'Säännöt sitovat jokaisen guest-NIC:n, jonka palomuuri on päällä, ryhmän scopen alla — viitattiin tai ei',
      enforceWarning: 'Pakotuksen nostaminen sitoo säännöt seuraavassa konvergenssissa JOKAISEEN guest-NIC:hen, jonka palomuuri on päällä, scopen {scope} alla, myös ilman eksplisiittistä viittausta — ja aktiivisen chainin sisällä esi-isän drop on lopullinen: alemmat tasot eivät avaa sitä uudelleen.',
      unenforceInfo: 'Pakotuksen poistaminen jättää säännöt vain niille NIC:eille, jotka viittaavat ryhmään eksplisiittisesti.',
      rules: 'Säännöt',
      tabOverview: 'Yleiskuva',
      tabRules: 'Säännöt',
      orderHint: 'Rivien järjestys ON evaluointijärjestys ryhmän sisällä: ensimmäinen täsmäävä sääntö voittaa.',
      statefulHint: 'Stateful on implisiittinen: vastaukset sallittuun liikenteeseen kulkevat itsestään (established/related hyväksytään, invalid pudotetaan — moottori injektoi ne, käsin niitä ei kirjoiteta).',
      noRules: 'Ei sääntöjä — rakenteilla oleva sanasto: siihen viittaaminen on luvallista eikä renderöi mitään.',
      addRule: 'Lisää sääntö',
      direction: 'Suunta',
      directionIn: 'Saapuva',
      directionOut: 'Lähtevä',
      action: 'Toiminto',
      action_accept: 'Hyväksy',
      action_drop: 'Pudota',
      action_reject: 'Hylkää',
      protocol: 'Protokolla',
      protocolAny: 'Mikä tahansa',
      ports: 'Portit',
      source: 'Lähde',
      dest: 'Kohde',
      comment: 'Kommentti',
      addressHint: 'IPv4-CIDR tai <fabric>/<looginen verkko>; tyhjä = mikä tahansa',
      moveUp: 'Siirrä ylös',
      moveDown: 'Siirrä alas',
      nicFirewall: 'Palomuuri',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Palomuuriryhmät',
      nicGroupsPlaceholder: 'Valitse ryhmä…',
      nicGroupsHint: 'Näkyvät ryhmät, ylempien scopien ryhmät mukaan lukien (käytettävissä alaspäin, kuten tagit)',
      nicGroupCount: { one: '{n} palomuuriryhmä', other: '{n} palomuuriryhmää' },
      nicOff: 'Palomuuri pois päältä',
      pendingRestartHint: 'Palomuurimuutokset noudattavat tallennettu/sovellettu-mallia: ne odottavat seuraavaa power cycleä (PendingRestart). Ylempien scopien pakottamat ryhmät pätevät, kun NIC:n palomuuri on päällä.',
      appConvergeHint: 'Palomuurimuutokset astuvat voimaan containerin seuraavassa konvergenssissa. Ylempien scopien pakottamat ryhmät pätevät, kun palomuuri on päällä.',
      enforcedAncestors: 'Ylempien scopien pakottamat',
      enforcedAncestorsHint: 'Tämä ryhmä pätee jokaiseen NIC:hen scopensa alla, jonka palomuuri on PÄÄLLÄ — kytkin on NIC:n pääkytkin (pois = ei chainia lainkaan, esi-isät mukaan lukien); aktiivisen chainin sisällä esi-isän auktoriteetti on lopullinen: sen droppia ei avata uudelleen alempana.'
    }
  }
}
